export default {
    name: 'InputCheckbox',

    data() {
        return {
            error: ''
        }
    },

    props: {
        label: String,
        value: String,
        checked: Boolean,
        required: Boolean,
        small: Boolean,
        disabled: Boolean
    },

    methods: {
        toggle() {
            if (!this.disabled) {
                this.$emit('toggle')
            }
        },

        checkForError() {
            this.error = this.checked || !this.required ? '' : 'input-text-error'
            return this.error
        }
    }
}